import React, { useState, useEffect } from 'react'
import {
    Box,
    Button,
    Grid,
    Typography,
} from '@mui/material'
import FAQItem from '../../components/ui/FAQ'
import axios from 'axios'
import { FAQUrl } from '../../common/url'
import { useTranslation } from 'react-i18next'
import { App_Language_key } from '../../common/config'

export const SMFAQ: React.FC = () => {

    const { t } = useTranslation()

    const [tabIndex, updateTabIndex] = useState(0)

    const [data, setData] = useState(null)

    const typeList = ['General', 'Motorcycle', 'Personal Loan', 'SHENMA Mobile', 'E-invoicing']

    useEffect(() => {
        (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabIndex])

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'

    const fetchList = async () => {
        try {
            var url = FAQUrl + '?publicationState=live&sort=sequence:ASC&filters[language][$eq]='+ language + '&filters[category][$eq]=' + typeList[tabIndex]
            const response = await axios.get(url)
            if (response.status === 200) {
                setData(null)
                setData(response.data['data'])
            }
        } catch (error) {
            console.error(error)
        }
    }

    const btnData = [
        {
            'title': t('t382'),
        },
        {
            'title': t('t383'),
        },
        {
            'title': t('t384'),
        },
        {
            'title': t('t385'),
        },
        {
            'title': t('t3851'),
        }
    ]

    const changeTabIndex = (index: number) => {
        updateTabIndex(index)
    }

    // ======================= RENDER FUNCTIONS
    const renderFaqAccordion = () => (
        <FAQItem data={data}></FAQItem>
    )

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            paddingLeft: '60px',
            paddingRight: '60px',
            paddingTop: '70px',
            paddingBottom: '40px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#FFFFFF'
        }}>
            <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                {t('t164')}
            </Typography>

            <Grid container columnSpacing={2} marginTop={'24px'} paddingLeft={'90px'} alignContent={'center'}>
                {btnData.map((item, index) => (
                    <Grid item key={index} xs={2}>
                        <Box sx={{
                            backgroundColor: index === tabIndex ? '#FFC107' : '#FFFFFF',
                            borderRadius: '30px',
                            border: index === tabIndex ? 'none' : '1px solid #141F39',
                            alignContent: 'center',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Button
                                fullWidth
                                onClick={() => changeTabIndex(index)}
                                sx={{
                                    height: '60px',
                                    color: '#141F39',
                                    textTransform: 'none',
                                    borderRadius: '30px',
                                    '&:hover': {
                                        bgcolor: 'rgba(251, 191, 35, 0.08)',
                                    },
                                }}

                            >
                                {btnData[index]['title']}
                            </Button>
                        </Box>
                    </Grid>
                ))}
            </Grid>

            <Box sx={{
                paddingTop: '40px',
            }}>
                {renderFaqAccordion()}
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMFAQ
